var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cmp-mdc-data-search',{on:{"query":_vm.onQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }